// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__KFfet","options":"AnswerScale_options__2nQFV","selected":"AnswerScale_selected__gLHHT"};